import React from "react";
import { Badge } from "../components/ui/badge";
import { Button } from "../components/ui/button";
import { Card, CardContent } from "../components/ui/card";
import { Input } from "../components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../components/ui/table";

import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { useModelIndex } from "@rhino-project/core/hooks";
import { asSubmission, listResults } from "../lib/thirdDoorAdapters";

export default function MySubmissions() {
    const { resources } = useModelIndex("submission" as any, { limit: 25 } as any);
    const rows = listResults(resources).map(asSubmission);
    const [query, setQuery] = useState("");
    const [status, setStatus] = useState("all");
    const filtered = useMemo(() => rows.filter((row) => {
      const queryMatch = row.name.toLowerCase().includes(query.toLowerCase());
      const statusMatch = status === "all" || row.status === status;
      return queryMatch && statusMatch;
    }), [query, status]);
    const resetFilters = () => {
      setQuery("");
      setStatus("all");
    };
  return (
   <div className="w-full min-w-0 bg-background text-foreground overflow-x-hidden">
      <div className="mx-auto flex w-full max-w-7xl min-w-0 flex-col gap-6 px-4 py-6 sm:px-6 lg:px-8">
          <section className="w-full space-y-4">
      <Card className="border-border shadow-sm">
      <CardContent className="grid gap-3 p-4 md:grid-cols-[1fr_220px_auto]">
      <Input value={query} onChange={(event) => setQuery(event.target.value)} placeholder="Search submissions" />
      <Select value={status} onValueChange={setStatus}>
      <SelectTrigger><SelectValue placeholder="Status" /></SelectTrigger>
      <SelectContent className="bg-popover text-popover-foreground">
      <SelectItem value="all">All statuses</SelectItem>
      <SelectItem value="Draft">Draft</SelectItem>
      <SelectItem value="Submitted">Submitted</SelectItem>
      <SelectItem value="Under Review">Under Review</SelectItem>
      <SelectItem value="Routed">Routed</SelectItem>
      <SelectItem value="Hold">Hold</SelectItem>
      </SelectContent>
      </Select>
      <Button variant="outline" onClick={resetFilters}>Reset</Button>
      </CardContent>
      </Card>

      <Card className="border-border shadow-sm">
      <CardContent className="p-0">
      <div className="overflow-x-auto">
      <Table>
      <TableHeader>
      <TableRow>
      <TableHead>Submission</TableHead>
      <TableHead>Status</TableHead>
      <TableHead>Confidence</TableHead>
      <TableHead>Navigator</TableHead>
      <TableHead>Updated</TableHead>
      <TableHead className="text-right">Action</TableHead>
      </TableRow>
      </TableHeader>
      <TableBody>
      {filtered.map((item) => (
      <TableRow key={item.id}>
      <TableCell className="font-medium">{item.name}</TableCell>
      <TableCell><Badge variant={item.status === "Routed" ? "default" : "secondary"}>{item.status}</Badge></TableCell>
      <TableCell>{item.confidence}</TableCell>
      <TableCell>{item.navigator}</TableCell>
      <TableCell>{item.updated}</TableCell>
      <TableCell className="text-right"><Button asChild size="sm" variant="outline"><Link to="/dual-use-on-ramp/readiness-routing">Open</Link></Button></TableCell>
      </TableRow>
      ))}
      </TableBody>
      </Table>
      </div>
      </CardContent>
      </Card>
      </section>
      </div>
    </div>
  );
}